import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import LoadingSpinner from './components/ui/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import NewHome from './pages/NewHome';
import NotFound from './pages/NotFound';

// Lazy load non-home pages to balance LCP (hero on /) and initial bundle size
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Portfolio = React.lazy(() => import('./pages/Portfolio'));
const Blogs = React.lazy(() => import('./pages/Blogs'));
const FAQ = React.lazy(() => import('./pages/FAQ'));
const Hiring = React.lazy(() => import('./pages/Hiring'));
const Products = React.lazy(() => import('./pages/Products'));
const ServiceDetail = React.lazy(() => import('./pages/ServiceDetail'));
const ITOutsourcing = React.lazy(() => import('./pages/services/ITOutsourcing'));
const CustomSoftwareDevelopment = React.lazy(() => import('./pages/services/CustomSoftwareDevelopment'));
const GoHighLevelExpert = React.lazy(() => import('./pages/services/GoHighLevelExpert'));
const Sitemap = React.lazy(() => import('./pages/Sitemap'));
const AICityDemo = React.lazy(() => import('./pages/AICityDemo'));

// Lazy load capability pages
const AI = React.lazy(() => import('./pages/capabilities/AI'));
const AI_Sales = React.lazy(() => import('./pages/capabilities/AI_Sales'));
const Mobile_Development = React.lazy(() => import('./pages/capabilities/Mobile_Development'));
const Web_Development = React.lazy(() => import('./pages/capabilities/Web_Development'));
const UI_UX = React.lazy(() => import('./pages/capabilities/UI_UX'));
const Cloud_Solution = React.lazy(() => import('./pages/capabilities/Cloud_Solution'));

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<LoadingSpinner />}>
          {/*
            New public URLs also need an entry in src/config/knownRoutes.ts.
            Otherwise Apache returns 404. See the comment in that file.
          */}
          <Routes>
            <Route path="/" element={<NewHome />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/products" element={<Products />} />
            <Route path="/service/:serviceId" element={<ServiceDetail />} />
            <Route path="/services/it-outsourcing" element={<ITOutsourcing />} />
            <Route path="/services/custom-software-development" element={<CustomSoftwareDevelopment />} />
            <Route path="/services/gohighlevel-expert" element={<GoHighLevelExpert />} />
            <Route path="/services/:serviceName" element={<ServiceDetail />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/ai-city" element={<AICityDemo />} />
            <Route path="/404" element={<NotFound />} />
            
            {/* Capability routes */}
            <Route path="/capabilities/ai" element={<AI />} />
            <Route path="/capabilities/ai-sales" element={<AI_Sales />} />
            <Route path="/capabilities/mobile-development" element={<Mobile_Development />} />
            <Route path="/capabilities/web-development" element={<Web_Development />} />
            <Route path="/capabilities/ui-ux" element={<UI_UX />} />
            <Route path="/capabilities/cloud-solution" element={<Cloud_Solution />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
